import { render, staticRenderFns } from "./TableSection.vue?vue&type=template&id=620fb01c&scoped=true&"
import script from "./TableSection.vue?vue&type=script&lang=js&"
export * from "./TableSection.vue?vue&type=script&lang=js&"
import style0 from "./TableSection.vue?vue&type=style&index=0&id=620fb01c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620fb01c",
  null
  
)

/* custom blocks */
import block0 from "./TableSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports